// extracted by mini-css-extract-plugin
export var blockedMessage = "_97-3";
export var blockedOverlay = "_97-1";
export var fadeIn = "_97-2";
export var hereLink = "_97-0";
export var slideUp = "_97-4";